"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DBCards = void 0;
var react_1 = __importStar(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var react_router_dom_1 = require("react-router-dom");
var styled_components_1 = __importDefault(require("styled-components"));
var __1 = require("../../..");
var StyledCardColumns = (0, styled_components_1.default)(react_bootstrap_1.Col)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  // Your styled-components CSS goes here\n"], ["\n  // Your styled-components CSS goes here\n"])));
var DBCards = function (props) {
    var _a = props, path = _a.path, expand = _a.expand, open = _a.open, link = _a.link;
    var logic = (0, __1.useEloise)().logic;
    var _b = (0, react_1.useState)(null), docs = _b[0], setDocs = _b[1];
    var _c = (0, react_1.useState)(null), sortColumn = _c[0], setSortColumn = _c[1];
    var _d = (0, react_1.useState)("asc"), sortDirection = _d[0], setSortDirection = _d[1];
    var _e = (0, react_1.useState)(null), expandedRowIndex = _e[0], setExpandedRowIndex = _e[1];
    var _f = (0, react_1.useState)(new Set()), selectedDocs = _f[0], setSelectedDocs = _f[1];
    var navigate = (0, react_router_dom_1.useNavigate)();
    logic.hooks.useAsyncEffect(function () { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, logic.fb.docs.getUserCollection(path)];
                case 1:
                    data = _a.sent();
                    setDocs(data);
                    return [2 /*return*/];
            }
        });
    }); }, []);
    // handleSort, sortDocs, handleRowClick, and getColumnOrder functions are the same as in the SortableTable component
    var handleSort = function (columnName) {
        if (sortColumn === columnName) {
            setSortDirection(sortDirection === "asc" ? "desc" : "asc");
        }
        else {
            setSortColumn(columnName);
            setSortDirection("asc");
        }
    };
    var handleRowClick = function (index, data) {
        if (expand) {
            if (expandedRowIndex === index) {
                setExpandedRowIndex(null);
            }
            else {
                setExpandedRowIndex(index);
            }
        }
        else if (open && link) {
            navigate(link, { state: { data: data } });
        }
    };
    var handleRowSelect = function (index) {
        var newSelectedDocs = new Set(selectedDocs);
        if (selectedDocs.has(index)) {
            newSelectedDocs.delete(index);
        }
        else {
            newSelectedDocs.add(index);
        }
        setSelectedDocs(newSelectedDocs);
    };
    var sortDocs = function () {
        if (!docs || !sortColumn)
            return docs;
        var sortedDocs = __spreadArray([], docs, true);
        sortedDocs.sort(function (a, b) {
            var aVal = a[sortColumn];
            var bVal = b[sortColumn];
            if (aVal < bVal)
                return sortDirection === "asc" ? -1 : 1;
            if (aVal > bVal)
                return sortDirection === "asc" ? 1 : -1;
            return 0;
        });
        return sortedDocs;
    };
    var isFirebaseTimestamp = function (value) {
        return typeof value !== "string";
    };
    var formatTimestamp = function (timestamp) {
        return JSON.stringify(timestamp);
    };
    var getColumnOrder = function () {
        if (!docs || docs.length === 0)
            return [];
        var keys = Object.keys(docs[0].data);
        var orderedKeys = ["title"];
        if (keys.includes("type"))
            orderedKeys.push("type");
        orderedKeys.push.apply(orderedKeys, keys.filter(function (key) { return !["title", "type"].includes(key); }));
        return orderedKeys;
    };
    var renderCards = function () {
        if (!docs)
            return null;
        var sortedDocs = sortDocs();
        if (sortedDocs) {
            return sortedDocs.map(function (doc, index) { return (react_1.default.createElement(react_bootstrap_1.Card, { className: "col-lg-4", key: index, onClick: function (e) {
                    e.stopPropagation();
                    if (expand) {
                        setExpandedRowIndex(expandedRowIndex === index ? null : index);
                    }
                    else if (open && link) {
                        navigate(link, { state: { data: doc.data } });
                    }
                } },
                react_1.default.createElement(react_bootstrap_1.Card.Body, null,
                    react_1.default.createElement("div", { style: { display: "flex", flexDirection: "column" } }, Object.entries(doc.data).map(function (_a, entryIndex) {
                        var key = _a[0], value = _a[1];
                        if (isFirebaseTimestamp(value)) {
                            value = formatTimestamp(value);
                        }
                        return (react_1.default.createElement("div", { key: "".concat(index, "-").concat(entryIndex), style: {
                                display: "flex",
                                justifyContent: "space-between",
                                marginBottom: "8px",
                            } },
                            react_1.default.createElement("label", null, logic.generic.capitalize(key)),
                            react_1.default.createElement("input", { type: "text", defaultValue: value })));
                    }))),
                expand && expandedRowIndex === index && react_1.default.createElement(react_bootstrap_1.Card.Footer, null))); });
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Row, null,
            react_1.default.createElement(react_bootstrap_1.Col, { lg: 3 },
                react_1.default.createElement(react_bootstrap_1.DropdownButton, { style: { textAlign: "left" }, id: "sort-dropdown", title: "Sort", variant: "secondary" }, getColumnOrder().map(function (key, index) { return (react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { key: index, onClick: function () { return handleSort(key); } },
                    logic.generic.capitalize(key),
                    sortColumn === key && (sortDirection === "asc" ? " ▲" : " ▼"))); })))),
        react_1.default.createElement(StyledCardColumns, null, renderCards())));
};
exports.DBCards = DBCards;
var templateObject_1;
